import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type { DataSourceListRequest, DataSourceListResponse } from '@/entities/datasource/domain/types';

type DataSourceListResponseWire = Omit<DataSourceListResponse, 'items'> & {
  items?: DataSourceListResponse['items'];
};

const DATASOURCE_BASE_URL = '/datasources';

export const getDataSourcesApi = async ({ maturity }: DataSourceListRequest): Promise<DataSourceListResponse> => {
  const response = await cycloneApiClient.get<DataSourceListResponseWire>(DATASOURCE_BASE_URL, {
    params: {
      maturity,
    },
  });

  return {
    ...response.data,
    items: response.data.items ?? [],
  };
};
